<div class="card card-primary card-outline style">
   
    <!------------Add edit button----------------->
   <a class="btn btn-info btn-sm edit" (click)='getValue();EditItem()'>
    <i class="fas fa-pencil-alt">
    </i>
    Edit
    </a>
  <!-------------------------------------------->
    
  
        <div>
  
          <table class="table style">
          
          <tbody>
          
   
        
            <tr>
            <td style="width: 40%;"><b>Month And Year :</b></td>
            <td>{{formatDate(output.month_year)}}</td>
            </tr>
  
            <tr>
            <td><b>Working Days :</b></td>
            <td>
              <div class="space" *ngFor="let d of output.working_days;index as i">
                  <span>{{DateFormat(d)}}</span>
                  </div>
            </td>
            </tr>
        
          </tbody>
      </table>      
  
  
